import { useMemo } from "react";
import { useChannels } from "./useChannels";
import { CHANNEL_TYPES } from "../constants/channelCatalog";

export function usePortalClienteChannelConfigured() {
  const { data, isLoading } = useChannels(1, 200, "");

  const configured = useMemo(
    () =>
      (data?.channels || []).some(
        (channel) => Number(channel.tipo) === CHANNEL_TYPES.XPRO_CLIENTE
      ),
    [data?.channels]
  );

  return { configured, isLoading };
}
